import { Head } from 'vite-react-ssg';
import { FOUNDER_PERSON_ID, founderPersonLd } from '@/lib/founder';

const organization = {
  '@type': 'Organization',
  '@id': 'https://ezcloud.ai/#organization',
  name: 'EZ Cloud',
  alternateName: [
    'EZ Cloud AI',
    'EzCloud',
    'ez cloud',
    'EZ Cloud AP Automation',
    'ezcloud.ai',
  ],
  url: 'https://ezcloud.ai/',
  logo: {
    '@type': 'ImageObject',
    url: 'https://ezcloud.ai/icon-512.png',
    width: 512,
    height: 512,
  },
  description:
    'AP automation engineered for Oracle — automating accounts-payable operations end-to-end on Oracle Fusion Cloud ERP and Oracle E-Business Suite, with prebuilt integrations for NetSuite, SAP, Microsoft Dynamics, and Yardi. Also an Oracle WebCenter and Fusion Middleware modernization consulting practice: 12c to 14c upgrades, WebCenter Forms Recognition, and the December 2026 Fusion Middleware 12c support window.',
  founder: { '@id': FOUNDER_PERSON_ID },
  memberOf: {
    '@type': 'ProgramMembership',
    programName: 'Oracle PartnerNetwork (OPN)',
    hostingOrganization: {
      '@type': 'Organization',
      name: 'Oracle',
      url: 'https://www.oracle.com/',
    },
  },
  sameAs: [
    'https://www.linkedin.com/company/ez-cloud-ai/',
    // Oracle's own pages about EZ Cloud — strongest third-party entity corroboration.
    'https://www.oracle.com/cloud/technical-case-studies/ez-cloud/',
    'https://docs.oracle.com/en/solutions/ez-cloud-on-oci/',
  ],
  knowsAbout: [
    'Accounts Payable Automation',
    'Oracle E-Business Suite Payables',
    'Oracle Fusion Cloud ERP',
    'Oracle WebCenter modernization',
    'Oracle WebCenter Forms Recognition',
    'Oracle Fusion Middleware 12c to 14c upgrades',
    'Oracle Cloud Infrastructure',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-856-834-5080',
    contactType: 'sales',
    email: 'hello@ezcloud.ai',
    availableLanguage: 'English',
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1134 S Black Horse Pike Suite 266',
    addressLocality: 'Blackwood',
    addressRegion: 'NJ',
    postalCode: '08012',
    addressCountry: 'US',
  },
};

const schema = {
  '@context': 'https://schema.org',
  '@graph': [organization, founderPersonLd],
};

const OrganizationSchema = () => (
  <Head>
    <script type="application/ld+json">{JSON.stringify(schema)}</script>
  </Head>
);

export default OrganizationSchema;
